<div class="main-container" [style.cursor]="expandable ? 'pointer' : 'inherit'" (click)="expand()">
  @if (expandable && !expanded) {
    <i class="fas fa-chevron-right"></i>
  }
  @if (expandable && expanded) {
    <i class="fas fa-chevron-down"></i>
  }
  {{ fieldConfig.label }}
</div>
<div [class.outer-border-box]="withBorder">
  @if (!expandable || expanded) {
    <div [class.inner-border-box]="withBorder">
      @if (loading) {
        <div class="spinner-container">
          <mat-spinner [diameter]="24"></mat-spinner>
        </div>
      }
      <div class="table-container">
        <table [ngClass]="{ 'striped-panel': fieldConfig.strippedRows }">
          @for (field of getFields(); track field) {
            <tr class="space-elements">
              @if (!field.formFullWidth && !field.noLabel) {
                <td class="row-elements">
                  @if (field.help) {
                    <button mat-icon-button color="primary" [matTooltip]="field.help">
                      <mat-icon class="info-icon">help</mat-icon>
                    </button>
                  }
                  <b>{{ field.label }}</b>
                </td>
              }
              <td class="table-form-data" [attr.colspan]="field.formFullWidth || field.noLabel ? 2 : 1">
                <app-form-field
                  [type]="field.type"
                  [data]="formGroupSubset.getRawValue()[field.name]"
                  [rowData]="formGroupSubset.getRawValue()"
                  [fieldConfig]="field"
                  [(editMode)]="editMode"
                  [(formGroup)]="formGroupSubset"></app-form-field>
              </td>
            </tr>
          }
        </table>
      </div>
    </div>
  }
</div>
